import type { ModalHeaderModel } from "../../type/modal";

export const ModalHeader: React.FC<ModalHeaderModel> = ({ title, onClose }) => (
  <div className="modal-header">
    <h4 className="modal-title">{title}</h4>

    {onClose && (
      <button
        type="button"
        className="modal-close"
        onClick={onClose}
        aria-label="Close"
      >
        &times;
      </button>
    )}
  </div>
);
